export default "__VITE_ASSET__U1gUsFeQ__"